export default __webpack_public_path__ + "static/media/onboardingLogo.a34e8ae0.svg";